export const loadLottie = require('bundle-loader?lazy&name=[name]!lottie-web');



// WEBPACK FOOTER //
// ./src/js/lib/async-bundles.js